export const roles = {admin: 1, pm: 2, fwp: 3}



// WEBPACK FOOTER //
// ./src/views/admin/constants.js